import { useState } from 'react';
import Select from '../Select';
import MicIcon from 'assets/icons/MicIcon';
import { ClonedVoice } from './components/types';
import { Box, Typography, Button } from '@mui/material';
import AddCloneVoiceModal from './components/AddCloneVoiceModal';
import { Control } from 'react-hook-form';

interface Props {
  control: Control<any>;
  name: string;
  cloneVoices: any;
}

export default function CloneVoiceSelector({ control, name, cloneVoices }: Props) {
  const [openModal, setOpenModal] = useState(false);

  return (
    <Box
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
        p: 2,
        borderRadius: 1,
        bgcolor: (theme) => theme.palette.background.paper,
        mb: 2
      }}
    >
      <Box display='flex' alignItems='start' justifyContent='space-between' mb={1}>
        <Box>
          <Typography variant='h6' color='text.primary'>
            Clone Voice
          </Typography>
          <Typography color='text.secondary' mb={1}>
            Select a clone voice you want to use or add new one.
          </Typography>
        </Box>
        <Button size='small' startIcon={<MicIcon />} onClick={() => setOpenModal(true)}>
          Add New
        </Button>
      </Box>
      <Select
        label='Voice'
        name={name}
        control={control}
        options={
          cloneVoices?.map((voice: ClonedVoice) => ({
            label: voice.name,
            value: voice.voice_id,
            audioUrl: voice.voice_url ?? undefined
          })) || []
        }
        required={false}
      />
      <AddCloneVoiceModal isOpen={openModal} onClose={() => setOpenModal(false)} />
    </Box>
  );
}
